import React from 'react';
import { FaWhatsapp, FaTiktok, FaFacebook } from 'react-icons/fa';

const QuickContactBar = () => {
  const socialLinks = [
    {
      icon: <FaWhatsapp />,
      url: 'https://wa.me/27739130901',
      label: 'WhatsApp'
    },
    {
      icon: <FaTiktok />,
      url: 'https://tiktok.com/@yolanisphotoshoot',
      label: 'TikTok'
    },
    {
      icon: <FaFacebook />,
      url: 'https://facebook.com/yolanisphotoshoot',
      label: 'Facebook'
    }
  ];

  return (
    <div className="quick-contact">
      <div className="container">
        <div className="quick-contact-content">
          <a href="tel:+27739130901">
            <span>Call: +27 73 913 0901</span>
          </a>
          <div className="quick-social">
            {socialLinks.map((social, index) => (
              <a 
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
              >
                {social.icon}
              </a>
            ))}
          </div>
          <a href="mailto:info@yolaniphotoshoot.co.za">
            <span>Email: info@yolaniphotoshoot.co.za</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default QuickContactBar;